export default __webpack_public_path__ + "static/ripples-group-4af9c9b2364769d95adfaf98fc51bd50.png";